import { Content } from "./Content";
import { RightSidebar } from "./RightSidebar";
import { RootLayout } from "./Root";

export const DetailPageLayout = Object.assign(RootLayout, {
  Content,
  RightSidebar,
});
